const crewRoleOptions = [
  'Captain',
  'Chief/First Officer',
  'Second Officer',
  'Chief/First Mate',
  'Bosun',
  'Mate',
  'Deckhand',
  'Chief Engineer',
  'Second Engineer',
  'Engineer',
  'ETO',
  'Sole Engineer',
  'Purser',
  'Chief Steward/ess',
  'Steward/ess',
  'Sole Stewardess',
  'Chef',
  'Sous/Crew Chef'
].map(e => [e, e]);

export default crewRoleOptions;
